import React from 'react';
import Layout from '../../components/Layout/Layout';
import Card from '../../components/Card/Card';
import styles from './CardPage.module.css';

const CardPage = () => {
  const handleCardSelect = (cardId) => {
    console.log(`Card selected: ${cardId}`);
  };

  return (
    <Layout width="1440px">
      <div className={styles.cardStack}>
        <Card
          cardId="8741ff4a-c1bc-4561-960e-0bc602cdb81a"
          size="Small"
          initialOpen={false}
          disableHover={false}
          autoPlay={true}
          hoverPlay={true}
          controls={false}
          loop={true}
          rotation={0}
          onCardSelect={handleCardSelect}
        />
      </div>
    </Layout>
  );
};

export default CardPage;